.hero {
  padding-block: clamp(48px, 8vw, 88px) clamp(56px, 9vw, 100px);
  position: relative;
  overflow: hidden;
}

.motif {
  position: absolute;
  top: 8%;
  left: 0;
  width: 46%;
  min-width: 320px;
  height: auto;
  pointer-events: none;
}
@media (max-width: 900px) {
  .motif {
    display: none;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: clamp(28px, 5vw, 60px);
  align-items: center;
  position: relative;
}
@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.label {
  display: block;
  font-size: var(--step--1);
  font-weight: 600;
  color: var(--text-secondary);
  margin-top: 18px;
}

.headline {
  margin-top: 16px;
  font-size: var(--step-5);
  text-transform: uppercase;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.lede {
  margin-top: 18px;
  font-size: var(--step-1);
  color: var(--text-secondary);
  max-width: 40ch;
}

.ctaRow {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-top: 28px;
  flex-wrap: wrap;
}

.explore {
  font-size: var(--step--1);
  font-weight: 700;
  color: var(--action);
  text-decoration: none;
}
.explore:hover {
  color: var(--action-hover);
}

.art {
  width: 100%;
  height: auto;
  position: relative;
}
